export const email = ({ userSetting }) => userSetting.base.email;
export const enabled = ({ userSetting }) => userSetting.base.enabled;
